import React from 'react'
import { RejectProceedingsDialog, SecondaryCta } from 'components'

/**
 * Display de total amount of the assets in the selected proceedings and gives and option to approve and send them or cancel
 * @param {object} params - The param object from the Mui DataGrid column definition
 * @returns {ReactComponentElement} - component with ammount format and button to toggle set assets dialog
 */
function GridRejectProceeding({ row }) {
  return (
    <RejectProceedingsDialog
      togglerComponent={SecondaryCta}
      togglerProps={{ size: 'grid' }}
      proceedingsList={[row]}
    >
      Rechazar lote
    </RejectProceedingsDialog>
  )
}

export const MemoizedGridRejectProceeding = React.memo(GridRejectProceeding)
